module.exports = cptable;


//////////////////
// WEBPACK FOOTER
// external "cptable"
// module id = 1990
// module chunks = 502